import _typeof from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.split";
import _slicedToArray from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
//
//
//

import { mergeNumberOfExps, validExp, toRPN, calcRPN, debounce } from "../../utils";
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: ["value", "formData", "expression", "rowIndex" // 计算公式放在表格中时， 需要获取在表格中的行位置
  ],
  name: 'calculate',
  data: function data() {
    return {
      innerValue: this.value,
      RPN_EXP: toRPN(mergeNumberOfExps(this.expression))
    };
  },
  computed: {
    rootFormData: function rootFormData() {
      return this.formData || this.getFormData();
    }
  },
  methods: {
    getFormData: function getFormData() {
      var root = this.$parent;
      while (root) {
        if ('vmFormData' in root) {
          return root.vmFormData;
        }
        root = root.$parent;
      }
    },
    /**
     * 获取指定组件的值
     */
    getFormVal: function getFormVal(vModel) {
      try {
        if (vModel.indexOf('.') > -1) {
          var _vModel$split = vModel.split('.'),
            _vModel$split2 = _slicedToArray(_vModel$split, 2),
            tabelVModel = _vModel$split2[0],
            cmpVModel = _vModel$split2[1];
          if (typeof this.rowIndex === 'number') {
            return this.rootFormData[tabelVModel][this.rowIndex][cmpVModel] || 0;
          } else {
            return this.rootFormData[tabelVModel].reduce(function (sum, c) {
              return (c[cmpVModel] ? Number(c[cmpVModel]) : 0) + sum;
            }, 0);
          }
        }
        return this.rootFormData[vModel] || 0;
      } catch (error) {
        console.warn('计算公式出错, 可能包含无效的组件值', error);
        return 0;
      }
    },
    /**
     * 计算表达式
     */
    execRPN: function execRPN() {
      var _this = this;
      var temp = this.RPN_EXP.map(function (t) {
        return _typeof(t) === 'object' ? _this.getFormVal(t.__vModel__) : t;
      });
      this.innerValue = calcRPN(temp);
      if (isNaN(this.innerValue)) this.innerValue = 0;
      this.$emit('input', this.innerValue);
    }
  },
  watch: {
    formData: {
      handler: function handler(val) {
        if (!val) return;
        if (!this.computeExps) {
          // formData更新可能比较频繁
          this.computeExps = debounce(this.execRPN, 500);
        }
        this.computeExps();
      },
      deep: true,
      immediate: true
    }
  }
};